<div class="container">
  <img
    class="back-button"
    (click)="dataService.withdrawStep = 0"
    src="assets/icons/news/back-arrow.svg"
    alt="back button"
  />

  <div class="title-container">
    <h3 *ngIf="dataService.withdrawStep !== 2">Retirar {{ type ? 'pesos' : 'dólares' }}</h3>
    <p *ngIf="dataService.withdrawStep !== 2">
      Enviá tus {{ type ? 'pesos' : 'dólares' }} a cualquier cuenta bancaria a tu nombre
    </p>
    <h3 *ngIf="dataService.withdrawStep === 2">
      Agregar cuenta en {{ type ? 'pesos' : 'dólares' }}
    </h3>
    <p *ngIf="dataService.withdrawStep === 2">
      Enviá tus {{ type ? 'pesos' : 'dólares' }} a cualquier cuenta bancaria a tu nombre
    </p>
  </div>

  <div class="accounts" *ngIf="dataService.withdrawStep === 1">
    <div class="accounts-list">
      <h3 class="subtitle">Enviar a</h3>
      <mat-form-field class="select-account" appearance="outline">
        <mat-select [formControl]="indexSelected">
          <mat-select-trigger>
            {{
              banksAccounts[indexSelected.value]?.alias
                ? banksAccounts[indexSelected.value].alias + ' - '
                : ''
            }}
            <div>
              <span>
                <img
                  style="height: 25px; vertical-align: top"
                  [src]="imageBank(banksAccounts[indexSelected.value]?.bankCode)"
                  #bankIconImg
                  (error)="bankIconErrorHandler(bankIconImg)"
                  alt="link"
                />
              </span>
              <span class="option">
                {{ banksAccounts[indexSelected.value]?.description }} -
                {{ banksAccounts[indexSelected.value]?.cbu }}
                {{
                  banksAccounts[indexSelected.value]?.bankName &&
                  banksAccounts[indexSelected.value]?.bankName !== '-'
                    ? '(' + getBankName(banksAccounts[indexSelected.value]) + ')'
                    : ''
                }}
              </span>
            </div>
          </mat-select-trigger>
          <mat-option (click)="router.navigate(['profile', 'accounts']); dialogRef.close()">
            <div
              style="
                display: flex !important;
                align-items: center !important;
                justify-content: center !important;
                z-index: 2;
                cursor: pointer;
              "
            >
              <span style="font-size: 16px; font-weight: 500; line-height: 16px; text-align: center"
                >Gestioná tus cuentas</span
              >
              <img
                style="width: 24px; height: 24px; position: relative; top: -2px; right: -5px"
                src="assets/icons/image-link.svg"
                alt="link"
              />
            </div>
          </mat-option>
          <img
            style="margin: auto; display: flex; width: 490px"
            src="assets/images/line.svg"
            alt="link"
          />
          <mat-option *ngFor="let acc of banksAccounts; let i = index" [value]="i">
            {{ acc.alias ? acc.alias + ' - ' : '' }}
            <div style="display: flex; align-items: center">
              <img
                style="height: 25px; vertical-align: middle; margin-right: 10px"
                [src]="imageBank(acc.bankCode)"
                alt="link"
                #bankIconImg
                (error)="bankIconErrorHandler(bankIconImg)"
              />
              <span class="option-description">
                {{ acc.description }} - {{ acc.cbu }}
                {{ acc.bankName && acc.bankName !== '-' ? '(' + acc.bankName + ')' : '' }}
              </span>
            </div>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div
      class="empty"
      *ngIf="!authService.loggedUser.bankAccounts[type === 0 ? 'USD' : 'ARS'].length"
    >
      <p>No tenés ningua cuenta bancaria, agregá usando el siguiente boton:</p>
    </div>
    <div class="amount">
      <h3 class="subtitle">Cantidad a retirar</h3>
      <div class="field" [class.margin-b]="type === 1">
        <span class="money-type">{{ type ? 'AR$' : 'US$' }}</span>
        <input
          type="text"
          placeholder="0"
          [formControl]="amount"
          mask="separator.2"
          thousandSeparator="."
        />
        <span class="max-btn" (click)="setMaxAmount()">
          <img src="/assets/icons/to_top.svg" alt="" />
        </span>
      </div>
    </div>
    <p class="available" *ngIf="type === Coin.DOLAR">
      Disponible: {{ authService.loggedUser.balance.fiat['USD'] | formatCoinAmount : 'USD' }} USD
    </p>
    <p class="available" *ngIf="type === Coin.PESO">
      Disponible: {{ authService.loggedUser.balance.fiat['ARS'] | formatCoinAmount : 'ARS' }} ARS
    </p>

    <p
      *ngIf="dataService.alertMessages.showWithdraw && dataService.alertMessages.withdraw"
      [class.loading]="loadingWithdraw"
      class="error"
    >
      {{ dataService.alertMessages.withdraw }}
    </p>

    <app-reminder-message
      *ngIf="isWithdrawDisabled"
      [message]="
        'Los retiros en ' +
        (this.type === 1 ? 'pesos' : 'dólares') +
        ' se encuentran temporalmente deshabilitados. Por favor, intentá mas tarde.'
      "
      type="warning"
    ></app-reminder-message>

    <app-reminder-message
      *ngIf="showReminderMessage"
      message="Entre las 23hs y las 2 am, el servicio bancario se encuentra realizando tareas de mantenimiento. En caso de existir error al retirar, probá más tarde."
      type="warning"
    ></app-reminder-message>

    <button class="td-btn primary createWithdraw" [disabled]="loadingWithdraw" (click)="withdraw()">
      <div *ngIf="loadingWithdraw" class="progress" [class.completed]="successfulWithdraw"></div>
      <p *ngIf="!loadingWithdraw">Retirar</p>
      <p *ngIf="loadingWithdraw && !successfulWithdraw">Cargando...</p>
      <img
        class="check"
        *ngIf="loadingWithdraw && successfulWithdraw"
        src="assets/icons/news/tick.svg"
        alt="check"
      />
    </button>
    <!-- <div class="sigBtn" *ngIf="indexSelected>-1">
      <div class="action-badge" (click)="withdraw()">
        <h3>RETIRAR A {{authService.loggedUser.accounts[type][indexSelected].alias.toUpperCase()}}</h3>
      </div>
    </div> -->
    <p class="checkbox-error">{{ errorMsg }}</p>
    <p class="error-code">{{ errorCode }}</p>
  </div>

  <div class="add" *ngIf="dataService.withdrawStep === 2">
    <div class="line">
      <h3 class="subtitle">Nombre del banco</h3>
      <div class="field">
        <input type="text" name="name" placeholder="Ej: Banco Macro" [formControl]="nameControl" />
        <label
          class="form-error"
          [class.invisible]="nameControl.pristine || !nameControl.invalid"
          >{{ getErrorMessage('name') }}</label
        >
      </div>

      <h3 class="subtitle">CBU/CVU/ALIAS*</h3>
      <div class="field no-error">
        <input
          type="text"
          name="cbu"
          placeholder=""
          [formControl]="cbuControl"
          (input)="cleanErrors()"
        />
      </div>
      <label
        class="checkbox-error"
        [class.no-display]="cbuControl.pristine || !cbuControl.invalid"
        >{{ getErrorMessage('cbu') }}</label
      >
      <label class="checkbox-error" [class.no-display]="!accountNotOwned"
        >Esta cuenta no se encuentra asociada a su CUIT.</label
      >
      <label class="checkbox-error" [class.no-display]="!notTrueCoin"
        >Ingresó una cuenta para {{ type == 0 ? 'pesos' : 'dólares' }} necesitamos una de
        {{ type != 0 ? 'pesos' : 'dólares' }}.</label
      >
      <label class="checkbox-error" [class.no-display]="!bindDown"
        >El sistema está bajo mantenimiento, volveremos pronto.</label
      >
      <p class="extra">
        Esta cuenta debe poder recibir {{ type ? 'pesos' : 'dólares' }} y tener de titular a
        <b>{{ authService.loggedUser.name }}</b>
      </p>
    </div>
    <button class="td-btn primary createWithdraw" [disabled]="addingAccount" (click)="addAccount()">
      <div *ngIf="addingAccount" class="progress" [class.completed]="successfulAccount"></div>
      <p *ngIf="!addingAccount">Agregar cuenta</p>
      <p *ngIf="addingAccount">Cargando...</p>
    </button>
  </div>

  <!-- <div class="loading"></div> -->
</div>
